import {
   ON_NEW_ORDER,ON_GET_ORDER_PAGE_BASIC,ON_START_ORDER_CLOSE_TOASTR,ON_GET_ORDER_PAGEROWS_BASIC,
   ON_START_NEW_ORDER,ON_UPDATE_ORDER_LIST_SEARCHTYPE,ON_UPDATE_ORDER_LIST_SEARCHWORD,
   ON_START_GET_ORDER_USER_NEXT_PREV,ON_GET_ORDER_USER_NEXT_PREV,ON_ERROR_GET_ORDER_USER_NEXT_PREV,
   ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE, ON_UPDATE_ORDER_KUNDDATA_KANUPDATE, ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE,
   ON_ERROR_NEW_ORDER,ON_GET_ORDER_KUNDDATA2_ID,
    ON_GET_ORDER_ORGNR,ON_GET_CHANGE_ORDER_VY_SORT,
    ON_ERROR_GET_ORDER_ORGNR,
    ON_START_GET_ORDER_ORGNR,ON_START_GET_ORDER_ORGNR_PROJEKT,ON_GET_ORDER_ORGNR_PROJEKT,
    ON_START_GET_ORDER_ID,ON_GET_ORDER_ID,ON_ERROR_GET_ORDER_ID,
    ON_START_GET_ORDER_REST_ID,ON_GET_ORDER_REST_ID,ON_ERROR_GET_ORDER_REST_ID,
    ON_START_DELETE_ORDER,
    ON_DELETE_ORDER,
    ON_ERROR_DELETE_ORDER,
    ON_START_GET_ORDER_USER,
    ON_GET_ORDER_USER,
    ON_ERROR_GET_ORDER_USER,
    ON_START_ORDER_NEW_DOC,
    ON_ORDER_NEW_DOC,
    ON_ERROR_ORDER_NEW_DOC,
    ON_START_GET_ORDER_DOC_ID,
    ON_GET_ORDER_DOC_ID,
    ON_ERROR_GET_ORDER_DOC_ID,
    ON_START_GET_ORDER_FORTNOX,ON_GET_ORDER_FORTNOX,ON_ERROR_GET_ORDER_FORTNOX,ON_UPDATE_ORDER_FORNOX,
    ON_START_DELETE_ORDER_DOC_RAD,    ON_DELETE_ORDER_DOC_RAD,    ON_ERROR_DELETE_ORDER_DOC_RAD,
    ON_START_UPDATE_ORDER_DOC_RAD,ON_UPDATE_ORDER_DOC_RAD,ON_ERROR_UPDATE_ORDER_DOC_RAD,
    ON_SAVE_ORDER_CALC_ITEMS,
    ON_START_SAVE_ORDER_CALC_ITEMS,
    ON_ERROR_SAVE_ORDER_CALC_ITEMS,
    ON_START_GET_ORDER_HISTORY_ID,
    ON_GET_ORDER_HISTORY_ID,
    ON_ERROR_GET_ORDER_HISTORY_ID,
    ON_START_NEW_ORDER_HANDELSE,
    ON_NEW_ORDER_HANDELSE,
    ON_ERROR_NEW_ORDER_HANDELSE,
    ON_START_NEW_ORDER_KALKYL_ID,
    ON_NEW_ORDER_KALKYL_ID,
    ON_ERROR_NEW_ORDER_KALKYL_ID, 
    ON_START_NEW_ORDER_ABOKALKYL_ID,
    ON_NEW_ORDER_ABOKALKYL_ID,
    ON_ERROR_NEW_ORDER_ABOKALKYL_ID,
    ON_START_GET_ORDER_KALKYL_ID,
    ON_GET_ORDER_KALKYL_ID,
    ON_ERROR_GET_ORDER_KALKYL_ID,
    ON_START_DELETE_ORDER_KALKYL_RAD,
    ON_DELETE_ORDER_KALKYL_RAD,
    ON_ERROR_DELETE_ORDER_KALKYL_RAD,
    ON_START_UPDATE_ORDER_KALKYL_RAD,
    ON_UPDATE_ORDER_KALKYL_RAD,
    ON_ERROR_UPDATE_ORDER_KALKYL_RAD,
    ON_START_NEW_ORDER_KONTAKT_ID,
    ON_NEW_ORDER_KONTAKT_ID,
    ON_ERROR_NEW_ORDER_KONTAKT_ID,
    ON_START_ORDER_INFO_UPDATE,
    ON_NEW_ORDER_INFO_UPDATE,
    ON_ERROR_ORDER_INFO_UPDATE,
    ON_START_ORDER_UPDATE,
    ON_ORDER_UPDATE,
    ON_ERROR_ORDER_UPDATE,
    ON_START_ORDER_KUNDDATA_INSERT,
    ON_NEW_ORDER_KUNDDATA_INSERT,
    ON_ERROR_ORDER_KUNDDATA_INSERT,
    ON_START_GET_ORDER_KUNDDATA_ID,
    ON_GET_ORDER_KUNDDATA_ID,
    ON_ERROR_GET_ORDER_KUNDDATA_ID,
    ON_START_ORDER_ANTAL_UPDATE,
    ON_NEW_ORDER_ANTAL_UPDATE,
    ON_ERROR_ORDER_ANTAL_UPDATE,
    ON_START_DELETE_ORDER_KUNDDATA_RAD,
    ON_DELETE_ORDER_KUNDDATA_RAD,
    ON_ERROR_DELETE_ORDER_KUNDDATA_RAD,
    ON_START_ORDER_KUNDDATA_COPYTA,
    ON_ORDER_KUNDDATA_COPYTA,
    ON_ERROR_ORDER_KUNDDATA_COPYTA,
    ON_START_ORDER_REGISTER,
    ON_NEW_ORDER_REGISTER,
    ON_ERROR_ORDER_REGISTER,
    ON_START_ORDER_REGISTER_KLAR,
    ON_NEW_ORDER_REGISTER_KLAR,
    ON_ERROR_ORDER_REGISTER_KLAR,
    ON_START_ORDER_REGISTER_SALES_MULTI, ON_ORDER_REGISTER_SALES_MULTI,ON_ERROR_ORDER_REGISTER_SALES_MULTI,
    ON_START_FORTNOX_NEWKUND_ORDER, ON_FORTNOX_NEWKUND_ORDER, ON_ERROR_FORTNOX_NEWKUND_ORDER,
    ON_ERROR_GET_OFFERT_KALKYL_ID,ON_GET_OFFERT_KALKYL_ID,ON_START_GET_OFFERT_KALKYL_ID,
    ON_START_DELETE_ORDER_HANDELSE,ON_DELETE_ORDER_HANDELSE,ON_ERROR_DELETE_ORDER_HANDELSE,
    ON_START_ORDER_REGISTER_BEHANDLA, ON_NEW_ORDER_REGISTER_BEHANDLA, ON_ERROR_ORDER_REGISTER_BEHANDLA,
    SET_ZERO_ORDER,
    ON_START_FETCH_EXCELMALL,ON_FETCH_EXCELMALL,ON_ERROR_EXCELMAL,
    ON_START_ORDER_DASHBOARD_UPDATE, ON_NEW_ORDER_DASHBOARD_UPDATE, ON_ERROR_ORDER_DASHBOARD_UPDATE,
    ON_OPEN_FILTER_ORDER, ON_ClOSE_FILTER_ORDER,SET_ORDER_FILTER,
    ON_START_SNABB_ORDER,ON_SNABB_ORDER,ON_ERROR_SNABB_ORDER,
    ON_START_FETCH_ORDER_RAPPORT,ON_FETCH_ORDER_RAPPORT,ON_ERROR_FETCH_ORDER_RAPPORT,
    ON_START_GET_ORDER_KEDJA,ON_GET_ORDER_KEDJA,ON_ERROR_GET_ORDER_KEDJA,
    ON_START_ORDER_KUNDDATA_TEMPORARY, ON_ORDER_KUNDDATA_TEMPORARY, ON_ERROR_ORDER_KUNDDATA_TEMPORARY,
    ON_START_ORDER_IMPORT_KD_EXCEL, ON_ORDER_IMPORT_KD_EXCEL, ON_ERROR_ORDER_IMPORT_KD_EXCEL,
    ON_START_GET_ORDER_USER_HV, ON_GET_ORDER_USER_HV, ON_ERROR_ORDER_USER_HV,
    ON_START_FORTNOX_SEND_ORDER, ON_FORTNOX_SEND_ORDER, ON_ERROR_FORTNOX_SEND_ORDER,
    ON_START_FORTNOX_CANCEL_ORDER, ON_FORTNOX_CANCEL_ORDER, ON_ERROR_FORTNOX_CANCEL_ORDER,
    ON_START_FETCH_EXCEL_KUNDDATA_ORDER,ON_FETCH_EXCEL_KUNDDATA_ORDER,ON_ERROR_EXCEL_KUNDDATA_ORDER,
    ON_START_GET_SEARCHABLE_ARTKEL_FI,ON_GET_SEARCHABLE_ARTKEL_FI,ON_ERROR_GET_SEARCHABLE_ARTKEL_FI,
    SET_ORDERVY_TYPE,UNSET_ORDERVY_TYPE,
    ON_GET_ORDER_STATUS_ANTAL,
    ON_ERROR_GET_ORDER_STATUS_ANTAL,
    ON_START_GET_ORDER_STATUS_ANTAL,
    ON_UPDATE_THIS_ORDER_STATUS,
    ON_ERROR_UPDATE_THIS_ORDER_STATUS,
    ON_START_UPDATE_THIS_ORDER_STATUS,
    ON_START_GET_ORDER_VARDE_TOOLTIP,
    ON_ERROR_GET_ORDER_VARDE_TOOLTIP,
    ON_GET_ORDER_VARDE_TOOLTIP,
    
    ON_START_CREATE_WOOCOMMERCE_ORDER,
    ON_CREATE_WOOCOMMERCE_ORDER,
    ON_ERROR_CREATE_WOOCOMMERCE_ORDER,
    ON_START_UPDATE_WOOCOMMERCE_ORDER,
    ON_UPDATE_WOOCOMMERCE_ORDER,
    ON_ERROR_UPDATE_WOOCOMMERCE_ORDER,
}
from "../constants/ActionTypes";
import {isUndefined} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
CurrentOrder:{},
OrderLogs:[],
OrderList:[],
OrderPage:1,
PageRows:25,
searchtype:0,
OrderListBUSER:[],
currentOrderDocs:[],
currentOrderHistory:[],
currentOrderKalkyl:[],
currentOrderKundData:[],
currentOrderVardeTooltip:[],
IsFromKd:0,
OrderUserlista:[],
searchableArtklerFI:[],
OrderMessage:"",
isOrderLoading:false,
isORLoading:false,
isLoadingKD:false,
isRapportLoading:false,
OpenSweetAlert:false,
OpenKlarSweetAlert:false,
TotalOrder:{},
ResponseMsg:{},
OrderFortnoxUppgifter:{},
FilterOrderPopup:false,
OrderFilterOption:isUndefined(localStorage.OrderFilter)?[]:JSON.parse(localStorage.OrderFilter), 
currentOrderVYIndex:isUndefined(localStorage.currentOrderVYIndex)?1:JSON.parse(localStorage.currentOrderVYIndex), 
OrderStatusAntal: [],
prevOrder:{id:0,OrderNr:0},
nextOrder:{id:0,OrderNr:0},
searchOrderWord:"",
HasNyFor:0,
OrderSortObj:isUndefined(localStorage.OrderSortObj)?{column: 'Regdate', Type: 1}:JSON.parse(localStorage.OrderSortObj),
CanU:0//canupdatekunddataprojekt

}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case SET_ZERO_ORDER:{
        return INIT_STATE;
      }
      //ON_GET_CHANGE_ORDER_VY_SORT
case ON_GET_CHANGE_ORDER_VY_SORT:{
  console.log("ON_GET_CHANGE_ORDER_VY_SORT",action)
  return {
    ...state,
    OrderSortObj:action.payload.OrderSortObj
  }
}
      case ON_UPDATE_THIS_ORDER_STATUS: {
        console.log("ON_UPDATE_THIS_ORDER_STATUS",action.payload)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.status.save"),type:"success",loading:false},
        }
      }
      case ON_ERROR_UPDATE_THIS_ORDER_STATUS: {
        console.log("ON_ERROR_UPDATE_THIS_ORDER_STATUS",action.payload)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Order.status.save"),type:"Error",loading:false},
        }
      }
      case ON_START_UPDATE_THIS_ORDER_STATUS: {
        console.log("ON_START_UPDATE_THIS_ORDER_STATUS",action.payload)
        return {
          ...state,
          ResponseMsg:{},
        }
      }
      case ON_START_GET_ORDER_VARDE_TOOLTIP: {
        console.log("ON_START_GET_ORDER_VARDE_TOOLTIP", action.payload)
        return {
          ...state,
          currentOrderVardeTooltip:[]
        }
      }
      case ON_ERROR_GET_ORDER_VARDE_TOOLTIP: {
        console.log("ON_ERROR_GET_ORDER_VARDE_TOOLTIP", action.payload)
        return {
          ...state,
          currentOrderVardeTooltip:[]
        }
      }
      case ON_GET_ORDER_VARDE_TOOLTIP: {
        console.log("ON_GET_ORDER_VARDE_TOOLTIP", action.payload)
        return {
          ...state,
          currentOrderVardeTooltip: action.payload.OrderVardeTooltip
        }
      }
      case ON_GET_ORDER_STATUS_ANTAL: {
        console.log("ON_GET_ORDER_STATUS_ANTAL", action.payload)
        return {
          ...state,
          OrderStatusAntal: action.payload.OrderStatusAntal
        }
      }
      case ON_ERROR_GET_ORDER_STATUS_ANTAL: {
        console.log("ON_ERROR_GET_ORDER_STATUS_ANTAL", action.payload)
        return {
          ...state,
        }
      }
      case ON_START_GET_ORDER_STATUS_ANTAL: {
        console.log("ON_START_GET_ORDER_STATUS_ANTAL", action.payload)
        return {
          ...state,
        }
      }
      case SET_ORDERVY_TYPE:{
        localStorage.setItem("currentOrderVYIndex", JSON.stringify(action.payload));
        return { ...state,
          currentOrderVYIndex: action.payload,
        };
      }
      case UNSET_ORDERVY_TYPE:{
        localStorage.removeItem("currentAvtalVYIndex");
        return { ...state,
          currentOrderVYIndex: 1,
        };
      }
      case SET_ORDER_FILTER: {
        console.log("SET_ORDER_FILTER",action.payload)
        localStorage.removeItem("OrderFilter");
        localStorage.setItem("OrderFilter", JSON.stringify(action.payload));
        return { ...state,
          OrderFilterOption: action.payload
        };
      }
        case ON_START_NEW_ORDER:{
            console.log("ON_START_NEW_ORDER",action)
            return {
              ...state,
              OrderMessage:"",
              ResponseMsg:{msg:translate("Action.Order.Creating"),type:"info",loading:true},
              isOrderLoading:true,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              CurrentOrder:{},
              currentOrderDocs:[],
              currentOrderHistory:[],
              currentOrderKalkyl:[],
              currentOrderKundData:[],
              OrderLogs:{},
              FilterOrderPopup:false,
              OrderListBUSER:[],
            }
          }
          case ON_OPEN_FILTER_ORDER:{
            console.log("ON_OPEN_FILTER_ORDER",action)
            return {
              ...state,
              FilterOrderPopup:true,
              OrderFilterOption:isUndefined(localStorage.OrderFilter)?[]:JSON.parse(localStorage.OrderFilter)
            }
          }
        case ON_ClOSE_FILTER_ORDER:{
            console.log("ON_ClOSE_FILTER_ORDER",action)
            return {
              ...state,
              FilterOrderPopup:false
            }
          }
        case ON_NEW_ORDER:{
            console.log("ON_NEW_ORDER",action)
            return {
              ...state,
              ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
              OrderMessage:"",
              CurrentOrder:action.payload.Order,
              OrderLogs:action.payload.Order.Order.OrderLogs,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              isOrderLoading:false,
              currentOrderHistory:{},
            }
          }
        case ON_ERROR_NEW_ORDER:{
            console.log("ON_ERROR_NEW_ORDER",action)
            return {
              ...state,
              isOrderLoading:false,
              OpenKlarSweetAlert:false,
              ResponseMsg:{msg:translate("Error.Order.create"),type:"error",loading:false},
              OrderMessage:"",
              CurrentOrder:{},
              OrderLogs:{}
            }
          }
        //,,,
        case ON_START_SNABB_ORDER:{
          console.log("ON_START_SNABB_ORDER",action)
          return {
            ...state,
            ResponseMsg:{msg:translate("Action.Order.Creating"),type:"info",loading:true},
            OrderMessage:"",
            isOrderLoading:true,
            OpenSweetAlert:false,
            OpenKlarSweetAlert:false,
            CurrentOrder:{},
            OrderLogs:{},
              currentOrderDocs:[],
              currentOrderHistory:[],
              currentOrderKalkyl:[],
              currentOrderKundData:[],
            FilterOrderPopup:false,
            OrderListBUSER:[],
          }
        }
        case ON_SNABB_ORDER:{
          console.log("ON_NEW_ORDER",action)
          return {
            ...state,
            ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
            OrderMessage:"",
            CurrentOrder:action.payload.Order,
            OrderLogs:action.payload.Order.Order.OrderLogs,
            OpenSweetAlert:false,
            OpenKlarSweetAlert:false,
            isOrderLoading:false,
            currentOrderHistory:{},
          }
        }
        case ON_ERROR_SNABB_ORDER:{
          console.log("ON_ERROR_SNABB_ORDER",action)
          return {
            ...state,
            ResponseMsg:{msg:translate("Error.Order.Quick.create"),type:"error",loading:false},
            isOrderLoading:false,
            OpenKlarSweetAlert:false,
            OrderMessage:"",
            CurrentOrder:{},
            OrderLogs:{},
          }
        }
        //
        case ON_START_GET_ORDER_ORGNR_PROJEKT:{
          console.log("ON_START_GET_ORDER_ORGNR",action)
          return {
            ...state,
            OrderMessage:"",
            OpenSweetAlert:false,
            OpenKlarSweetAlert:false,
            TotalOrder:0,
            currentOrderDocs:[],
            currentOrderHistory:[],
            currentOrderKalkyl:[],
            currentOrderKundData:[],
            OrderLogs:{},
            OrderList:[]
          }
        }
        case ON_GET_ORDER_ORGNR_PROJEKT:{
          console.log("ON_GET_ORDER_ORGNR",action)
          return {
            ...state,
            OrderMessage:"",
            OrderList:action.payload.Orders,
            TotalOrder:action.payload.Antal,
           // CurrentOrder:{},
            OrderLogs:{},
            currentOrderHistory:{},
          }
        }
        //ON_GET_ORDER_ORGNR_PROJEKT
        case ON_START_GET_ORDER_ORGNR:{
            console.log("ON_START_GET_ORDER_ORGNR",action)
            return {
              ...state,
              OrderMessage:"",
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              TotalOrder:0,
              CurrentOrder:{},
              currentOrderDocs:[],
              currentOrderHistory:[],
              currentOrderKalkyl:[],
              currentOrderKundData:[],
              OrderLogs:{},
              OrderList:[]
            }
          }
        case ON_ERROR_GET_ORDER_ORGNR:{
            console.log("ON_ERROR_GET_ORDER_ORGNR",action)
            return {
              ...state,
              OrderMessage:translate("Error.Orders.get"),
              CurrentOrder:{},
              OrderLogs:{},
            }
          }
        case ON_GET_ORDER_ORGNR:{
            console.log("ON_GET_ORDER_ORGNR",action)
            return {
              ...state,
              OrderMessage:"",
              OrderList:action.payload.Orders,
              TotalOrder:action.payload.Antal,
              CurrentOrder:{},
              OrderLogs:{},
              currentOrderHistory:{},
            }
          }
//ON_START_FORTNOX_SEND_ORDER, ON_FORTNOX_SEND_ORDER, ON_ERROR_FORTNOX_SEND_ORDER,
case ON_START_FORTNOX_SEND_ORDER:{
  console.log("ON_START_FORTNOX_SEND_ORDER",action)
  return { 
    ...state,
    ResponseMsg:{msg:translate("Action.Order.Fortnox.sending"),type:"info",loading:true},
    OrderMessage:"",
    OpenSweetAlert:false,
    OpenKlarSweetAlert:false,
    isOrderLoading:true,
    }
}
case ON_ERROR_FORTNOX_SEND_ORDER:{
  console.log("ON_ERROR_FORTNOX_SEND_ORDER",action)
  return {
    ...state,
    isOrderLoading:false,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
    OrderMessage:""
  }
}
case ON_FORTNOX_SEND_ORDER:{
  console.log("ON_FORTNOX_SEND_ORDER",action)
  return {
    ...state,
    OrderMessage:"",
    ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
    isOrderLoading:false,
    CurrentOrder:{
      ...state.CurrentOrder,
      Order:action.payload.Order.Order
    },
    OrderLogs:action.payload.Order.Order.OrderLogs,
    currentOrderHistory:{},
  }
}
//ON_START_FORTNOX_CANCEL_ORDER, ON_FORTNOX_CANCEL_ORDER, ON_ERROR_FORTNOX_CANCEL_ORDER,
case ON_START_FORTNOX_CANCEL_ORDER:{
  console.log("ON_START_FORTNOX_CANCEL_ORDER",action)
  return { 
    ...state,
    ResponseMsg:{msg:translate("Action.Order.Fortnox.cancel"),type:"info",loading:true},
    OrderMessage:"",
    OpenSweetAlert:false,
    OpenKlarSweetAlert:false,
    isOrderLoading:true,
    }
}
case ON_ERROR_FORTNOX_CANCEL_ORDER:{
  console.log("ON_ERROR_FORTNOX_CANCEL_ORDER",action)
  return {
    ...state,
    isOrderLoading:false,
    ResponseMsg:{msg:action.payload,type:"error",loading:false},
    OrderMessage:""
  }
}
case ON_FORTNOX_CANCEL_ORDER:{
  console.log("ON_FORTNOX_CANCEL_ORDER",action)
  return {
    ...state,
    OrderMessage:"",
    ResponseMsg:{msg:action.payload.message,type:"success",loading:false},
    isOrderLoading:false,
    CurrentOrder:{
      ...state.CurrentOrder,
      Order:action.payload.Order.Order
    },
    OrderLogs:action.payload.Order.Order.OrderLogs,
    currentOrderHistory:{},
  }
}
//ON_START_GET_ORDER_REST_ID,ON_GET_ORDER_REST_ID,ON_ERROR_GET_ORDER_REST_ID,
case ON_START_GET_ORDER_REST_ID:{
  return {
    ...state
  }
}
case ON_GET_ORDER_REST_ID:{
  return {
    ...state,
    OrderLogs:action.payload.Order.Order.OrderLogs,
    CurrentOrder:{
      ...state.CurrentOrder,
      Kalkyl:action.payload.Order.Kalkyl,
      antalDoc:action.payload.Order.antalDoc,
      Taggar:action.payload.Order.Taggar
    }
  }
}
case ON_ERROR_GET_ORDER_REST_ID:{
  return {
    ...state
  }
}
//

        case ON_GET_ORDER_ID:{
            console.log("ON_GET_ORDER_ID",action)
            return {
              ...state,
              ResponseMsg:{},
              OrderMessage:"",
              isOrderLoading:false,
              CurrentOrder:action.payload.Order,
              OrderLogs:action.payload.Order.Order.OrderLogs,
              currentOrderHistory:{},
            }
          }
        case ON_START_GET_ORDER_ID:{
            console.log("ON_START_GET_ORDER_ID",action)
            return {
              ...state,
              OrderMessage:"",              
              ResponseMsg:{msg:translate("Action.Order.geting"),type:"info",loading:true},
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              isOrderLoading:true,
             // CurrentOrder:{},
              OrderLogs:{},
              currentOrderDocs:[],
              currentOrderHistory:[],
              currentOrderKalkyl:[],
              currentOrderKundData:[],
            }
          }
        case ON_ERROR_GET_ORDER_ID:{
            console.log("ON_ERROR_GET_ORDER_ID",action)
            return {
              ...state,
              isOrderLoading:false,
              OrderMessage:"",
              ResponseMsg:{msg:action.payload,type:"error",loading:false},
              //CurrentOrder:{},
              OrderLogs:{},
            }
          }
        case ON_START_DELETE_ORDER:{
            console.log("ON_START_DELETE_ORDER",action)
            return {
              ...state,
              OrderMessage:"",
              ResponseMsg:{msg:translate("Action.Order.deleting"),type:"info",loading:true},
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              CurrentOrder:{},
              OrderLogs:{},
              isOrderLoading:true,
              currentOrderHistory:{},
            }
          }
        case ON_ERROR_DELETE_ORDER:{
            console.log("ON_ERROR_DELETE_ORDER",action)
            return {
              ...state,
              isOrderLoading:false,
              OrderMessage:"",
              ResponseMsg:{msg:action.payload,type:"error",loading:false},
              CurrentOrder:{},
              OrderLogs:{},
            }
          }
        case ON_DELETE_ORDER:{
            console.log("ON_DELETE_ORDER",action)
            if(action.payload.results.isList == 1){
              console.log(1,"12")
              return {
                ...state,
                ResponseMsg:{msg:translate("Action.Order.delete"),type:"error",loading:false},
                OrderMessage:"",
                isOrderLoading:false,
                OrderListBUSER:action.payload.results.Orders,
              }
            }else{
              return {
                ...state,
                ResponseMsg:{msg:translate("Action.Order.delete"),type:"error",loading:false},
                OrderMessage:translate("Action.Order.delete"),
                isOrderLoading:false,
                OrderList:action.payload.results.Orders,
              }
            }
          }
        case ON_START_GET_ORDER_USER:{
            console.log("ON_START_GET_ORDER_USER",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              isOrderLoading:true,
              ResponseMsg:{},
              CurrentOrder:{},
              currentOrderDocs:[],
              currentOrderHistory:[],
              currentOrderKalkyl:[],
              currentOrderKundData:[],
              OrderLogs:{},
             // OrderListBUSER:[],
              OrderMessage:"",
            }
          }
        case ON_ERROR_GET_ORDER_USER:{
            console.log("ON_ERROR_GET_ORDER_USER",action)
            return {
              ...state,
              isOrderLoading:false,
            //  OrderListBUSER:[],
              OrderMessage:translate("Error.Orders.get"),
            }
          } 
        case ON_GET_ORDER_USER:{
            console.log("ON_GET_ORDER_USER",action)
            return {
              ...state,
              OrderMessage:"",
              isOrderLoading:false,
              OrderListBUSER:action.payload.Orders,
              TotalOrder:action.payload.Antal,
            }
          }
        //ON_START_GET_ORDER_KEDJA,ON_GET_ORDER_KEDJA,ON_ERROR_GET_ORDER_KEDJA,
        case ON_START_GET_ORDER_KEDJA:{
          console.log("ON_START_GET_ORDER_KEDJA",action)
          return {
            ...state,
            OpenSweetAlert:false,
            OpenKlarSweetAlert:false,
            isOrderLoading:true,
            CurrentOrder:{},
            currentOrderDocs:[],
            currentOrderHistory:[],
            currentOrderKalkyl:[],
            currentOrderKundData:[],
            OrderLogs:{},
            OrderMessage:"",
          }
        }
        case ON_GET_ORDER_KEDJA:{
          console.log("ON_GET_ORDER_KEDJA",action)
          return {
            ...state,
            OrderMessage:"",
            isOrderLoading:false,
            OrderListBUSER:action.payload.Orders,
            TotalOrder:action.payload.Antal,
          }
        }
        case ON_ERROR_GET_ORDER_KEDJA:{
          console.log("ON_ERROR_GET_ORDER_KEDJA",action)
          return {
            ...state,
            isOrderLoading:false,
          //  OrderListBUSER:[],
            OrderMessage:translate("Error.Orders.get"),
          }
        } 
        //
        case ON_START_ORDER_NEW_DOC:{
            console.log("ON_START_ORDER_NEW_DOC",action)
            return {
              ...state,
              OrderMessage:"",
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              isOrderLoading:true,
            }
          }
        case ON_ORDER_NEW_DOC:{
            console.log("ON_ORDER_NEW_DOC",action)
            return {
              ...state,
              OrderMessage:translate("Action.Order.save"),
              isOrderLoading:false,
              CurrentOrder:{
                ...state.CurrentOrder,
                Order:action.payload.Order.Order
              },
              OrderLogs:action.payload.Order.Order.OrderLogs,
              currentOrderHistory:{},
              currentOrderDocs:action.payload.Docs,
            }
          }
        case ON_ERROR_ORDER_NEW_DOC:{
            console.log("ON_ERROR_ORDER_NEW_DOC",action)
            return {
              ...state,
              isOrderLoading:false,
              OrderMessage:translate("Error.Order.doc.save")
            }
          }
          case ON_START_GET_ORDER_DOC_ID:{
            console.log("ON_START_GET_ORDER_DOC_ID",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }
        case ON_ERROR_GET_ORDER_DOC_ID:{
            console.log("ON_ERROR_GET_ORDER_DOC_ID",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.doc.get")
            }
          }
        case ON_GET_ORDER_DOC_ID:{
            console.log("ON_GET_ORDER_DOC_ID",action)
            return {
              ...state,
              OrderMessage:"",
              currentOrderDocs:action.payload.Docs,
            }
          }
          //ON_START_UPDATE_ORDER_DOC_RAD,ON_UPDATE_ORDER_DOC_RAD,ON_ERROR_UPDATE_ORDER_DOC_RAD,
          case ON_START_UPDATE_ORDER_DOC_RAD:{
            console.log("ON_START_UPDATE_ORDER_DOC_RAD",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }
        case ON_ERROR_UPDATE_ORDER_DOC_RAD:{
            console.log("ON_ERROR_UPDATE_ORDER_DOC_RAD",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.doc.save")
            }
          }
        case ON_UPDATE_ORDER_DOC_RAD:{
            console.log("ON_UPDATE_ORDER_DOC_RAD",action)
            return {
              ...state,
              OrderMessage:translate("Action.Order.doc.save"),
              currentOrderDocs:action.payload.Docs,
              
            }
          }
          //
          case ON_START_DELETE_ORDER_DOC_RAD:{
            console.log("ON_START_DELETE_ORDER_DOC_RAD",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }
        case ON_ERROR_DELETE_ORDER_DOC_RAD:{
            console.log("ON_ERROR_DELETE_ORDER_DOC_RAD",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.doc.delete")
            }
          }
        case ON_DELETE_ORDER_DOC_RAD:{
            console.log("ON_DELETE_ORDER_DOC_RAD",action)
            return {
              ...state,
              OrderMessage:translate("Action.Order.doc.delete"),
              currentOrderDocs:action.payload.Docs,
              
            }
          }
          case ON_START_GET_ORDER_HISTORY_ID:{
            console.log("ON_START_GET_ORDER_HISTORY_ID",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }
        case ON_ERROR_GET_ORDER_HISTORY_ID:{
            console.log("ON_ERROR_GET_ORDER_HISTORY_ID",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.History.get")
            }
          }
        case ON_GET_ORDER_HISTORY_ID:{
            console.log("ON_GET_ORDER_HISTORY_ID",action)
            return {
              ...state,
              OrderMessage:"",
              currentOrderHistory:action.payload.History,
            }
          }
          case ON_START_NEW_ORDER_HANDELSE:{
            console.log("ON_START_NEW_ORDER_HANDELSE",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }
        case ON_ERROR_NEW_ORDER_HANDELSE:{
            console.log("ON_ERROR_NEW_ORDER_HANDELSE",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.new.Event")
            }
          }
        case ON_NEW_ORDER_HANDELSE:{
            console.log("ON_NEW_ORDER_HANDELSE",action)
            return {
              ...state,
              OrderMessage:translate("Action.Order.saved"),
              OrderLogs:action.payload.Order.Order.OrderLogs,
            }
          }

        case ON_SAVE_ORDER_CALC_ITEMS: {
            return {
              ...state,
              OrderMessage:translate("Action.Order.saved"),
              CurrentOrder:{
                ...state.CurrentOrder,
                Kalkyl:action.payload.OrderKalkyl
              },
              currentOrderKalkyl:action.payload.Kalkyl,
            }
        }
        case ON_START_SAVE_ORDER_CALC_ITEMS: {
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
        }
        case ON_ERROR_SAVE_ORDER_CALC_ITEMS: {
            return {
              ...state,
              OrderMessage:translate("Error.Order.new.Clac.Row")
            }
        }

          case ON_START_NEW_ORDER_KALKYL_ID:{
            console.log("ON_START_NEW_ORDER_KALKYL_ID",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }

        case ON_ERROR_NEW_ORDER_KALKYL_ID:{
            console.log("ON_ERROR_NEW_ORDER_KALKYL_ID",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.new.Clac.Row")
            }
          }
        case ON_NEW_ORDER_KALKYL_ID:{
            console.log("ON_NEW_ORDER_KALKYL_ID",action)
            return {
              ...state,
              OrderMessage:translate("Action.Order.saved"),
              CurrentOrder:{
                ...state.CurrentOrder,
                Order:action.payload.Order.Order
              },
              OrderLogs:action.payload.Order.Order.OrderLogs,
              currentOrderKalkyl:action.payload.Kalkyl,
            }
          }
          case ON_START_NEW_ORDER_ABOKALKYL_ID:{
            console.log("ON_START_NEW_ORDER_ABOKALKYL_ID",action)
            return {
              ...state,
              OpenSweetAlert:false,
              OpenKlarSweetAlert:false,
              OrderMessage:""
            }
          }
        case ON_ERROR_NEW_ORDER_ABOKALKYL_ID:{
            console.log("ON_ERROR_NEW_ORDER_ABOKALKYL_ID",action)
            return {
              ...state,
              OrderMessage:translate("Error.Order.new.Clac.Row")
            }
          }
        case ON_NEW_ORDER_ABOKALKYL_ID:{
            console.log("ON_NEW_ORDER_ABOKALKYL_ID",action)
            return {
              ...state,
              OrderMessage: translate("Action.Order.saved"),
              CurrentOrder:{
                ...state.CurrentOrder,
                Order:action.payload.Order.Order
              },
              OrderLogs:action.payload.Order.Order.OrderLogs,
              currentOrderKalkyl:action.payload.Kalkyl,
            }
          }
        case ON_START_GET_ORDER_KALKYL_ID:{
        console.log("ON_START_GET_ORDER_KALKYL_ID",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          currentOrderKalkyl:{},
          OrderMessage:""
        }
      }
    case ON_ERROR_GET_ORDER_KALKYL_ID:{
        console.log("ON_ERROR_GET_ORDER_KALKYL_ID",action)
        return {
          ...state,
          OrderMessage:translate("Error.Order.get.Clac.Row")
        }
      }
    case ON_GET_ORDER_KALKYL_ID:{
        console.log("ON_GET_ORDER_KALKYL_ID",action)
        return {
          ...state,
          OrderMessage:"",
          currentOrderKalkyl:action.payload.Kalkyl,
        }
      }
      //ON_START_GET_OFFERT_KALKYL_ID,ON_GET_OFFERT_KALKYL_ID,ON_START_GET_OFFERT_KALKYL_ID,
      case ON_START_GET_OFFERT_KALKYL_ID:{
        console.log("ON_START_GET_OFFERT_KALKYL_ID",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_ERROR_GET_OFFERT_KALKYL_ID:{
        console.log("ON_ERROR_GET_OFFERT_KALKYL_ID",action)
        return {
          ...state,
          OrderMessage:translate("Error.Order.get.Clac.Row")
        }
      }
    case ON_GET_OFFERT_KALKYL_ID:{
        console.log("ON_GET_OFFERT_KALKYL_ID",action)
        return {
          ...state,
          OrderMessage:"",
          currentOrderKalkyl:action.payload.Kalkyl,
        }
      }
      //
      case ON_START_DELETE_ORDER_KALKYL_RAD:{
        console.log("ON_START_DELETE_ORDER_KALKYL_RAD",action)
        return {
          ...state,
          ResponseMsg:{},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:"",
          isORLoading:true
        }
      }
    case ON_ERROR_DELETE_ORDER_KALKYL_RAD:{
        console.log("ON_ERROR_DELETE_ORDER_KALKYL_RAD",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Order.delete.Clac.Row"),type:"Error",loading:false},
          //OrderMessage:"Error",
          isORLoading:false
        }
      }
    case ON_DELETE_ORDER_KALKYL_RAD:{
        console.log("ON_DELETE_ORDER_KALKYL_RAD",action)
        console.log("currentOrderKalkyl",action.payload.results.Kalky)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.delete.Calc.Row"),type:"warning",loading:false},
          //OrderMessage:"Raderad",
          currentOrderKalkyl:action.payload.results.Kalkyl,
          OrderLogs:action.payload.results.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.results.Order.Order
          },
          isORLoading:false
        }
      }
      case ON_START_UPDATE_ORDER_KALKYL_RAD:{
        console.log("ON_START_UPDATE_ORDER_KALKYL_RAD",action)
        return {
          ...state,
          ResponseMsg:{},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_ERROR_UPDATE_ORDER_KALKYL_RAD:{
        console.log("ON_ERROR_UPDATE_ORDER_KALKYL_RAD",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Order.update.Calc.Row"),type:"Error",loading:false},
          //OrderMessage:"Error"
        }
      }
    case ON_UPDATE_ORDER_KALKYL_RAD:{
        console.log("ON_UPDATE_ORDER_KALKYL_RAD",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.update.Calc.Row"),type:"success",loading:false},
          //OrderMessage:"Spara",
          currentOrderKalkyl:action.payload.Kalkyl,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_START_NEW_ORDER_KONTAKT_ID:{
        console.log("ON_START_NEW_ORDER_KONTAKT_ID",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_NEW_ORDER_KONTAKT_ID:{
        console.log("ON_NEW_ORDER_KONTAKT_ID",action)
        return {
          ...state,
          OrderMessage:translate("Action.Order.saved"),
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_NEW_ORDER_KONTAKT_ID:{
        console.log("ON_ERROR_NEW_ORDER_KONTAKT_ID",action)
        return {
          ...state,
          OrderMessage:translate("Error.Order.new.Contact")
        }
      }
    case ON_START_ORDER_INFO_UPDATE:{
        console.log("ON_START_ORDER_INFO_UPDATE",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_NEW_ORDER_INFO_UPDATE:{
        console.log("ON_NEW_ORDER_INFO_UPDATE",action)
        return {
          ...state,
          OrderMessage:translate("Action.Order.saved"),
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_ORDER_INFO_UPDATE:{
        console.log("ON_ERROR_ORDER_INFO_UPDATE",action)
        return {
          ...state,
          OrderMessage:translate("Error.Oder.update.information")
        }
      }

      
    case ON_START_CREATE_WOOCOMMERCE_ORDER: {
      console.log("ON_START_CREATE_WOOCOMMERCE_ORDER","this.props.CurrentOrder22")
      return {
        ...state,
        ResponseMsg:{msg:translate("Action.Order.Woocommerce.creating"),type:"info",loading:true},
      }
    }
    case ON_CREATE_WOOCOMMERCE_ORDER: {
      console.log("ON_START_CREATE_WOOCOMMERCE_ORDER","this.props.CurrentOrder22")
      return {
        ...state,
        CurrentOrder:{
          ...state.CurrentOrder,
          Order: {
            ...state.CurrentOrder.Order,
            ['0']: {
              ...state.CurrentOrder.Order['0'],
              WoocommerceId: action.payload.WoocommerceId
            }
          }
        },
        ResponseMsg:{msg:translate("Action.Order.Woocommerce.create"),type:"success",loading:false},
      }
    }
    case ON_ERROR_CREATE_WOOCOMMERCE_ORDER: {
      console.log("ON_START_CREATE_WOOCOMMERCE_ORDER","this.props.CurrentOrder22")
      return {
        ...state,
        ResponseMsg:{msg:translate("Error.Order.Woocommerce.create"),type:"error",loading:false},
      }
    }
    
    case ON_START_UPDATE_WOOCOMMERCE_ORDER: {
      return {
        ...state,
        ResponseMsg:{msg:translate("Action.Order.Woocommerce.updating"),type:"info",loading:true},
      }
    }
    case ON_UPDATE_WOOCOMMERCE_ORDER: {
      return {
        ...state,
        ResponseMsg:{msg:translate("Action.Order.Woocommerce.update"),type:"success",loading:false},
      }
    }
    case ON_ERROR_UPDATE_WOOCOMMERCE_ORDER: {
      return {
        ...state,
        ResponseMsg:{msg:translate("Error.Order.Woocommerce.update"),type:"error",loading:false},
      }
    }

    case ON_START_ORDER_UPDATE:{
        console.log("ON_START_ORDER_UPDATE",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_ORDER_UPDATE:{
        console.log("ON_ORDER_UPDATE",action)
        return {
          ...state,
          OrderMessage:translate("Action.Order.saved"),
          OrderLogs:action.payload.Order.Order.OrderLogs,
         // CurrentOrder:action.payload.Order
        }
      }
    case ON_ERROR_ORDER_UPDATE:{
        console.log("ON_ERROR_ORDER_UPDATE",action)
        return {
          ...state,
          OrderMessage:translate("Error.Oder.update.information")
        }
      }
    case ON_START_ORDER_KUNDDATA_INSERT:{
        console.log("ON_START_ORDER_KUNDDATA_INSERT",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          isLoadingKD:true,
          OrderMessage:"",
          currentOrderKundData:[]
        }
      }
    case ON_NEW_ORDER_KUNDDATA_INSERT:{
        console.log("ON_NEW_ORDER_KUNDDATA_INSERT",action)
        return {
          ...state,
          OrderMessage:translate("Action.Order.saved"),
          isLoadingKD:false,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          currentOrderKundData:action.payload.KundData,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_ORDER_KUNDDATA_INSERT:{
        console.log("ON_ERROR_ORDER_KUNDDATA_INSERT",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:translate("Error.Order.ClientsData.add")
        }
      }
    case ON_START_GET_ORDER_KUNDDATA_ID:{
        console.log("ON_START_GET_ORDER_KUNDDATA_ID",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:"",
          isLoadingKD:true,
          CanU:0,
          HasNyFor:0,
          currentOrderKundData:[]
        }
      }
    case ON_GET_ORDER_KUNDDATA_ID:{
        console.log("ON_GET_ORDER_KUNDDATA_ID",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:"",
          currentOrderKundData:action.payload.KundData,
          CanU:action.payload.CanU,
          HasNyFor:action.payload.HasNyFor,
          IsFromKd:isUndefined(action.payload.isFromKunData)?0:action.payload.isFromKunData,
        }
      }
    case ON_GET_ORDER_KUNDDATA2_ID:{
        console.log("ON_GET_ORDER_KUNDDATA_ID",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:"",
          currentOrderKundData:action.payload.KundData,
          IsFromKd:isUndefined(action.payload.isFromKunData)?0:action.payload.isFromKunData,
        }
      }
    case ON_ERROR_GET_ORDER_KUNDDATA_ID:{
        console.log("ON_ERROR_GET_ORDER_KUNDDATA_ID",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:translate("Error.Order.ClientsData.get")
        }
      }
    case ON_START_ORDER_ANTAL_UPDATE:{
        console.log("ON_START_ORDER_ANTAL_UPDATE",action)
        return {
          ...state,
          OrderMessage:"",
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          isLoadingKD:true,
          currentOrderKundData:[]
        }
      }
    case ON_NEW_ORDER_ANTAL_UPDATE:{
        console.log("ON_NEW_ORDER_ANTAL_UPDATE",action)
        return {
          ...state,
          OrderMessage:translate("Action.Order.saved"),
          currentOrderKundData:action.payload.KundData,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
          isLoadingKD:false,
        }
      }
    case ON_ERROR_ORDER_ANTAL_UPDATE:{
        console.log("ON_ERROR_ORDER_ANTAL_UPDATE",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:translate("Error.Order.Quantity.update")
        }
      }
      case ON_START_DELETE_ORDER_KUNDDATA_RAD:{
        console.log("ON_START_DELETE_ORDER_KUNDDATA_RAD",action)
        return {
          ...state,
          isLoadingKD:true,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:"",
          currentOrderKundData:[],
        }
      }
    case ON_DELETE_ORDER_KUNDDATA_RAD:{
        console.log("ON_DELETE_ORDER_KUNDDATA_RAD",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:translate("Action.Order.ClientData.rad.delete"),
          OrderLogs:action.payload.Order.Order.OrderLogs,
          currentOrderKundData:action.payload.KundData,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_DELETE_ORDER_KUNDDATA_RAD:{
        console.log("ON_ERROR_DELETE_ORDER_KUNDDATA_RAD",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:translate("Error.Order.ClientData.rad.delete")
        }
      }
      case ON_START_ORDER_KUNDDATA_COPYTA:{
        console.log("ON_START_ORDER_KUNDDATA_COPYTA",action)
        return {
          ...state,
          isLoadingKD:true,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:"",
          currentOrderKundData:[]
        }
      }
    case ON_ORDER_KUNDDATA_COPYTA:{
        console.log("ON_ORDER_KUNDDATA_COPYTA",action)
        return {
          ...state,
          OrderMessage:"Sparad",
          isLoadingKD:false,
          currentOrderKundData:action.payload.KundData
        }
      }
    case ON_ERROR_ORDER_KUNDDATA_COPYTA:{
        console.log("ON_ERROR_ORDER_KUNDDATA_COPYTA",action)
        return {
          ...state,
          isLoadingKD:false,
          OrderMessage:translate("Error.Order.ClientData.copy,column")
        }
      }
      case ON_START_ORDER_REGISTER:{
        console.log("ON_START_ORDER_REGISTER",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.registering"),type:"info",loading:true},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_NEW_ORDER_REGISTER:{
        console.log("ON_NEW_ORDER_REGISTER",action)
        return {
          ...state,
          OrderMessage:"",
          ResponseMsg:{},
          OpenSweetAlert:true,
          OpenKlarSweetAlert:false,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_ORDER_REGISTER:{
        console.log("ON_ERROR_ORDER_REGISTER",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Order.registering"),type:"error",loading:false},
          OrderMessage:""
        }
      }
      case ON_START_ORDER_REGISTER_KLAR:{
        console.log("ON_START_ORDER_REGISTER_KLAR",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.registering.Complete"),type:"info",loading:true},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:""
        }
      }
    case ON_NEW_ORDER_REGISTER_KLAR:{
        console.log("ON_NEW_ORDER_REGISTER_KLAR",action)
        return {
          ...state,
          OrderMessage:"",
          ResponseMsg:{},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:true,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_ORDER_REGISTER_KLAR:{
        console.log("ON_ERROR_ORDER_REGISTER_KLAR",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Order.registering.Complete"),type:"error",loading:false},
          OrderMessage:""
        }
      }

      case ON_START_ORDER_REGISTER_SALES_MULTI: {
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Orders.registerging.sales"),type:"info",loading:true},
          OrderMessage:""
        }
      } 
      case ON_ORDER_REGISTER_SALES_MULTI: {
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Orders.register.sales"),type:"success",loading:false},
          OrderMessage:""
        }
      }
      case ON_ERROR_ORDER_REGISTER_SALES_MULTI: {
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Orders.register.sales"),type:"error",loading:false},
          OrderMessage:""
        }
      }

      case ON_START_ORDER_REGISTER_BEHANDLA:{
        console.log("ON_START_ORDER_REGISTER_BEHANDLA",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.getbackStatus"),type:"info",loading:true},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:"",
          OrderLogs:{},
          //CurrentOrder:{}
        }
      }
    case ON_NEW_ORDER_REGISTER_BEHANDLA:{
        console.log("ON_NEW_ORDER_REGISTER_BEHANDLA",action)
        return {
          ...state,
          OrderMessage:"",
          ResponseMsg:{msg:translate("Action.Order.saved"),type:"success",loading:false},
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_ORDER_REGISTER_BEHANDLA:{
        console.log("ON_ERROR_ORDER_REGISTER_BEHANDLA",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Error.Order.getbackStatus"),type:"error",loading:false},
          OrderMessage:""
        }
      }
      //, , ,
      case ON_START_ORDER_DASHBOARD_UPDATE:{
        console.log("ON_START_ORDER_DASHBOARD_UPDATE",action)
        return {
          ...state,
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderMessage:"",
          OrderLogs:{},
          ResponseMsg:{}
          //CurrentOrder:{}
        }
      }
    case ON_NEW_ORDER_DASHBOARD_UPDATE:{
        console.log("ON_NEW_ORDER_DASHBOARD_UPDATE",action)
        return {
          ...state,
          ResponseMsg:{msg:translate("Action.Order.update.Dashboard"),type:"success",loading:false},
         // OrderMessage:"Uppdaterad",
          OpenSweetAlert:false,
          OpenKlarSweetAlert:false,
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
        }
      }
    case ON_ERROR_ORDER_DASHBOARD_UPDATE:{
        console.log("ON_ERROR_ORDER_DASHBOARD_UPDATE",action)
        return {
          ...state,
          OrderMessage:translate("Error.Order.update.Dashboard")
        }
      }
      //,,,
      case ON_START_FETCH_ORDER_RAPPORT:{
        console.log("ON_START_FETCH_ORDER_RAPPORT",action)
        return {
            ...state,  
            isOrderLoading:true
          //  RapportFile:[] 
        }
    }
    case ON_FETCH_ORDER_RAPPORT:{
        console.log("ON_FETCH_ORDER_RAPPORT",action)
        return {
            ...state,
            isOrderLoading:false
          //  RapportFile:action.payload.AdminStatistik,
        }
    }
    case ON_ERROR_FETCH_ORDER_RAPPORT:{
        console.log("ON_ERROR_FETCH_ORDER_RAPPORT",action)
        return {
            ...state,
            isOrderLoading:false,
            message:translate("Error.Order.get.Report")
        }
    }
//

      //,,,
      case ON_START_DELETE_ORDER_HANDELSE:{
        console.log("ON_START_DELETE_ORDER_HANDELSE",action)
        return {
            ...state,
          //  RapportFile:[] 
        }
    }
    case ON_DELETE_ORDER_HANDELSE:{
        console.log("ON_DELETE_ORDER_HANDELSE",action)
        return {
            ...state,
            OrderMessage:translate("Action.Order.delete.event"),
            OrderLogs:action.payload.Order.Order.OrderLogs,
            CurrentOrder:{
              ...state.CurrentOrder,
              Order:action.payload.Order.Order
            },
        }
    }
    case ON_ERROR_DELETE_ORDER_HANDELSE:{
        console.log("ON_ERROR_DELETE_ORDER_HANDELSE",action)
        return {
            ...state,
            OrderMessage:translate("Error.Order.delete.event")
        }
    }
      //
    case "RESET_SWEET_KLAR":{
        return {
          ...state,
          OpenKlarSweetAlert:false
        }
      }
    case "RESET_SWEET":{
        return {
          ...state,
          OpenSweetAlert:false
        }
      }
    case ON_START_ORDER_KUNDDATA_TEMPORARY:{
      console.log("ON_START_ORDER_KUNDDATA_TEMPORARY",action)
      return {
          ...state,
      }
    }
    case ON_ORDER_KUNDDATA_TEMPORARY:{
      console.log("ON_ORDER_KUNDDATA_TEMPORARY",action)
      return {
          ...state,
      }
    }
    case ON_ERROR_ORDER_KUNDDATA_TEMPORARY:{
      console.log("ON_ERROR_ORDER_KUNDDATA_TEMPORARY",action)
      return {
          ...state,
      }
    }
    //ON_START_FETCH_EXCELMALL,ON_FETCH_EXCELMALL,ON_ERROR_EXCELMAL,
    case ON_START_FETCH_EXCELMALL:{
      console.log("ON_START_FETCH_EXCELMALL",action)
      return {
          ...state,
      }
    }
    case ON_FETCH_EXCELMALL:{
      console.log("ON_FETCH_EXCELMALL",action)
      return {
          ...state,
      }
    }
    case ON_ERROR_EXCELMAL:{
      console.log("ON_ERROR_EXCELMAL",action)
      return {
          ...state,
          OrderMessage:translate("Error.Order.get.Excel.Template"),
      }
    }
    //ON_START_ORDER_IMPORT_KD_EXCEL, ON_ORDER_IMPORT_KD_EXCEL, ON_ERROR_ORDER_IMPORT_KD_EXCEL,
    case ON_START_ORDER_IMPORT_KD_EXCEL:{
      console.log("ON_START_ORDER_IMPORT_KD_EXCEL",action)
      return {
        ...state,
        OpenSweetAlert:false,
        OpenKlarSweetAlert:false,
        isLoadingKD:true,
        OrderMessage:"",
       // currentOrderKundData:[]
      }
    }
  case ON_ORDER_IMPORT_KD_EXCEL:{
      console.log("ON_ORDER_IMPORT_KD_EXCEL",action)
      return {
        ...state,
        OrderMessage:translate("Action.Order.import.Excel"),
        isLoadingKD:false,
        currentOrderKundData:action.payload.KundData
      }
    }
  case ON_ERROR_ORDER_IMPORT_KD_EXCEL:{
      console.log("ON_ERROR_ORDER_IMPORT_KD_EXCEL",action)
      return {
        ...state,
        isLoadingKD:false,
        OrderMessage:translate("Error.Order.import.Excel")
      }
    }
    //ON_START_FORTNOX_NEWKUND_ORDER, ON_FORTNOX_NEWKUND_ORDER, ON_ERROR_FORTNOX_NEWKUND_ORDER,
    case ON_START_FORTNOX_NEWKUND_ORDER:{
      console.log("ON_START_FORTNOX_NEWKUND_ORDER",action)
      return {
          ...state,
        //  RapportFile:[] 
      }
  }
  case ON_FORTNOX_NEWKUND_ORDER:{
      console.log("ON_FORTNOX_NEWKUND_ORDER",action)
      return {
          ...state,
          OrderMessage:translate("Action.Order.Fortnox.Client.Connect"),
          OrderLogs:action.payload.Order.Order.OrderLogs,
          CurrentOrder:{
            ...state.CurrentOrder,
            Order:action.payload.Order.Order
          },
      }
  }
  case ON_ERROR_FORTNOX_NEWKUND_ORDER:{
      console.log("ON_ERROR_FORTNOX_NEWKUND_ORDER",action)
      return {
          ...state,
          OrderMessage:action.payload,
      }
  }
  //
  case ON_START_GET_ORDER_USER_HV:{
    console.log("ON_START_GET_ORDER_USER",action)
    return {
        ...state,
        OrderUserlista:[] 
    }
}
case ON_GET_ORDER_USER_HV:{
    //console.log("ON_GET_ORDER_USER",action)
    //console.log("ON_GET_ORDER_USER",action.payload)
    //console.log("ON_GET_ORDER_USER",action.payload.Users)
    return {
        ...state,
        OrderUserlista:action.payload.Users,
    }
}
case ON_ERROR_ORDER_USER_HV:{
    return {
        ...state
    }
}
//ON_GET_ORDER_PAGE_BASIC
case ON_GET_ORDER_PAGE_BASIC:{
  return {
    ...state,
    OrderPage:action.payload.Page
  }
}
case ON_GET_ORDER_PAGEROWS_BASIC:{
  return {
    ...state,
    PageRows:action.payload.PageRows
  }
}
//ON_START_FETCH_EXCEL_KUNDDATA_ORDER,ON_FETCH_EXCEL_KUNDDATA_ORDER,ON_ERROR_EXCEL_KUNDDATA_ORDER,
case ON_START_FETCH_EXCEL_KUNDDATA_ORDER:{
  return {
      ...state
  }
}
case ON_FETCH_EXCEL_KUNDDATA_ORDER:{
  return {
      ...state
  }
}
case ON_ERROR_EXCEL_KUNDDATA_ORDER:{
  return {
      ...state
  }
}
//ON_START_GET_ORDER_FORTNOX,ON_GET_ORDER_FORTNOX,ON_ERROR_GET_ORDER_FORTNOX,
case ON_START_GET_ORDER_FORTNOX:{
  return {
      ...state,
      OrderFortnoxUppgifter:{}
  }
}
case ON_GET_ORDER_FORTNOX:{
  return {
      ...state,
      OrderFortnoxUppgifter:action.payload.OrderFortnoxUppgifter
  }
}
case ON_ERROR_GET_ORDER_FORTNOX:{
  return {
      ...state
  }
}
case ON_UPDATE_ORDER_FORNOX:{
  console.log("ON_UPDATE_ORDER_FORNOX",action)
  return {
      ...state,
      OrderFortnoxUppgifter:action.payload
  }
}
//ON_START_ORDER_CLOSE_TOASTR
case ON_START_ORDER_CLOSE_TOASTR:{
  return {
      ...state,
      ResponseMsg:{}
  }
}
//ON_UPDATE_ORDER_LIST_SEARCHTYPE
case ON_UPDATE_ORDER_LIST_SEARCHTYPE:{
  console.log("ON_UPDATE_ORDER_LIST_SEARCHTYPE",action)
  return {
      ...state,
      searchtype:action.payload
  }
}
//ON_UPDATE_ORDER_LIST_SEARCHWORD
case ON_UPDATE_ORDER_LIST_SEARCHWORD:{
  console.log("ON_UPDATE_ORDER_LIST_SEARCHWORD",action)
  return {
      ...state,
      searchOrderWord:action.payload
  }
}
//ON_START_GET_SEARCHABLE_ARTKEL_FI,ON_GET_SEARCHABLE_ARTKEL_FI,ON_ERROR_GET_SEARCHABLE_ARTKEL_FI,
case ON_START_GET_SEARCHABLE_ARTKEL_FI:{
  return {
      ...state
  }
}
case ON_ERROR_GET_SEARCHABLE_ARTKEL_FI:{
  return {
      ...state
  }
}
case ON_GET_SEARCHABLE_ARTKEL_FI:{
  console.log("ON_GET_SEARCHABLE_ARTKEL_FI",action)
  return {
      ...state,
      searchableArtklerFI:action.payload.searchableArtklerFI
  }
}
//searchableArtklerFI
//ON_START_GET_ORDER_USER_NEXT_PREV,ON_GET_ORDER_USER_NEXT_PREV,ON_ERROR_GET_ORDER_USER_NEXT_PREV,
case ON_START_GET_ORDER_USER_NEXT_PREV:{
  return {
      ...state,
      nextOrder:{id:0,OrderNr:0},
      prevOrder:{id:0,OrderNr:0},
  }
}
case ON_GET_ORDER_USER_NEXT_PREV:{
  return {
      ...state,
      nextOrder:action.payload.nextOrder,
      prevOrder:action.payload.prevOrder,
  }
}
case ON_ERROR_GET_ORDER_USER_NEXT_PREV:{
  return {
      ...state,
  }
}
//ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE, ON_UPDATE_ORDER_KUNDDATA_KANUPDATE, ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE,
case ON_START_UPDATE_ORDER_KUNDDATA_KANUPDATE:{
  return {
      ...state,
  }
}
case ON_UPDATE_ORDER_KUNDDATA_KANUPDATE:{
  return {
      ...state,
  }
}
case ON_ERROR_UPDATE_ORDER_KUNDDATA_KANUPDATE:{
  return {
      ...state,
  }
}
//
        default:
            return state;
        }
    }
